import { Divider } from '@material-ui/core';
import React from 'react';
import DividerLine from '../../../../shared/email-services/divider-line/DividerLine';
import './DividerComponetBox.scss';

const DividerComponentBox = (props) => {
  const { componentObj, onClickComponent, componentNdx, isPreview } = props;
  const onComponentClick = () => {
    componentObj.index = componentNdx;
    componentObj.selected = true;
    onClickComponent(componentObj, componentNdx);
  };

  return (
    <div className='my-2'>
      <div
        className={`card layout-card email-divider col-md-12 d-flex justify-content-center align-items-center ${
          !isPreview && componentObj.selected ? 'layout-card-selected' : ''
        }`}
        onClick={() => onComponentClick()}
        style={{
          backgroundColor: componentObj?.hexCode || '#82828214',
          height: '80px !important',
          padding: componentObj?.padding
            ? `${componentObj?.top || 0}px ${componentObj?.right || 0}px ${
                componentObj?.bottom || 0
              }px ${componentObj?.left || 0}px`
            : '10px',
        }}
      >
        <Divider
          className='divider-line'
          style={{
            borderBottom: `2px solid ${componentObj?.color || 'black'}`,
            color: componentObj?.color,
            opacity: componentObj?.opacity,
          }}
        />
      </div>
    </div>
  );
};

export default DividerComponentBox;
